import { useTownStore, type Toast } from "../state/store";

/** One toast with its action buttons (presentational; server-rendered in unit tests). */
export function ToastView({ toast, onDismiss }: { toast: Toast; onDismiss(id: number): void }) {
  const t = toast;
  return (
    <div className={`toast ${t.tone}`} data-testid="toast">
      {t.text}{" "}
      {t.actions?.map((a) => (
        <button
          key={a.label}
          type="button"
          className="btn btn-sm toast-action"
          onClick={() => {
            onDismiss(t.id);
            a.run();
          }}
        >
          {a.label}
        </button>
      ))}
      <button type="button" className="btn btn-ghost btn-sm" style={{ color: "#fff" }} aria-label="Dismiss" onClick={() => onDismiss(t.id)}>
        ×
      </button>
    </div>
  );
}

/** `fixed`: on plain pages the stack stays in the viewport corner while the page scrolls. */
export function Toasts({ fixed = false }: { fixed?: boolean } = {}) {
  const toasts = useTownStore((s) => s.ui.toasts);
  const dismiss = useTownStore((s) => s.dismissToast);
  if (toasts.length === 0) return null;
  return (
    <div className={fixed ? "toasts toasts-fixed" : "toasts"} role="status" aria-live="polite">
      {toasts.map((t) => (
        <ToastView key={t.id} toast={t} onDismiss={dismiss} />
      ))}
    </div>
  );
}
